import { INTEGRATION_NAMES } from './integrations';

// align this list with the one in functions/constants/integrations
export const INTEGRATIONS_CLIENT_PROFILE_FIELDS = [
  'address1',
  'address2',
  'postalCode',
  'state',
  'city',
  'email',
  'phone',
  'firstName',
  'lastName',
  'gender',
  'birthDate',
  'units',
  'reference',
  'country',
];

// align this list with the one in functions/constants/integrations
export const EXCLUDE_CLIENT_PROFILE_FIELDS_SYNC = {
  [INTEGRATION_NAMES.LUMARY]: ['units'],
};

export const CLIENT_DATA_COLUMN_GROUP = 'clientData';

export const CLIENT_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
};

export const EDIT_CLIENT_PROFILE_TABS = {
  PROFILE: 'profile',
  CLINICAL: 'clinical',
  INFORMATION: 'information',
  ACCESS: 'users',
  AVAILABILITY: 'availability',
  AUTHORIZATIONS: 'authorizations',
};
